export default "__VITE_ASSET__BJR1d9FD__"